import {messageAddSuccess, messageAddError} from "./reducer";
import {postAddMessage} from "../../../helpers/message_helper";

export const addMessage = (payload) => async (dispatch) => {
  try {
    let response;
    response = postAddMessage(payload);
    const data = await response;

    if (data) {
      dispatch(messageAddSuccess());
    }
  } catch (error) {
    dispatch(messageAddError(error));
  }
};
